import { typeof as _typeof, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Box, TextButton, IconArrowLeftOutline, ProgressStepper, IconButton, IconClose } from '@zillow/constellation';

var INVISIBLE_SX = {
  visibility: 'hidden',
  pointerEvents: 'none'
};
function PAFormStepper(props) {
  var steps = React.Children.toArray(props.children).filter(function (child) {
    return _typeof(child) === 'object' && child !== null && 'type' in child && child.type === PAFormStepper.Step;
  });

  // Take the first footer element, the rest are ignored
  var _React$Children$toArr = React.Children.toArray(props.children).filter(function (child) {
      return _typeof(child) === 'object' && child !== null && 'type' in child && child.type === PAFormStepper.Footer;
    }),
    _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 1),
    footer = _React$Children$toArr2[0];

  // Gets the first visible step. If another has visbile=true it is treated as hidden.
  var visibleStep = steps.find(function (step) {
    return step.props.name === props.visibleStepName;
  });
  var hasBackButton = !!(visibleStep !== null && visibleStep !== void 0 && visibleStep.props.onBack);
  var hasProgressBar = !!(visibleStep !== null && visibleStep !== void 0 && visibleStep.props.progressBar);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      padding: '$spacing.sm'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'grid',
      gridTemplateColumns: '1fr 3fr 1fr',
      marginBottom: '$spacing.xxl'
    }
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    as: TextButton,
    sx: !hasBackButton && INVISIBLE_SX,
    disabled: !hasBackButton,
    onClick: visibleStep === null || visibleStep === void 0 ? void 0 : visibleStep.props.onBack,
    icon: /*#__PURE__*/React.createElement(IconArrowLeftOutline, null)
  }, "Back")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    as: ProgressStepper,
    sx: Object.assign({
      margin: '0 $spacing.xxl'
    }, !hasProgressBar && INVISIBLE_SX),
    activeStepIndex: hasProgressBar ? visibleStep.props.progressBar.current - 1 : -1,
    steps: hasProgressBar ? Array.from({
      length: visibleStep.props.progressBar.total
    }, function (_, i) {
      return {
        label: '',
        appearance: i < visibleStep.props.progressBar.current ? 'complete' : undefined
      };
    }) : ['']
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      justifySelf: 'end',
      alignSelf: 'center'
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    appearance: "circle",
    buttonType: "tertiary",
    size: "sm",
    icon: /*#__PURE__*/React.createElement(IconClose, null),
    onClick: props.onClose,
    title: "Close"
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'grid',
      gridTemplateColumns: '1fr 3fr 1fr',
      marginBottom: '$spacing.xxl'
    }
  }, /*#__PURE__*/React.createElement(Box, null), /*#__PURE__*/React.createElement(Box, {
    as: "form",
    sx: {
      display: 'grid',
      '> *': {
        gridArea: '1 / 1'
      }
    },
    onSubmit: props.onSubmit
  }, steps.map(function (step) {
    return /*#__PURE__*/React.createElement(Box, {
      key: step.props.name,
      sx: step.props.name === props.visibleStepName ? undefined : {
        visibility: 'hidden',
        pointerEvents: 'none'
        //   select: 'none',
      }
    }, step);
  })), /*#__PURE__*/React.createElement(Box, null)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'grid',
      gridTemplateColumns: '1fr 3fr 1fr',
      marginBottom: '$spacing.xxl'
    }
  }, /*#__PURE__*/React.createElement(Box, null), footer && /*#__PURE__*/React.createElement(Box, null, footer), /*#__PURE__*/React.createElement(Box, null)));
}
PAFormStepper.Step = function (props) {
  return props.children;
};
PAFormStepper.Footer = function (props) {
  return props.children;
};

export { PAFormStepper as default };
